<script>
  import { External, M } from '../../external';
  import { createEventDispatcher, onMount } from 'svelte';
  import { LmsCircleUtils } from './LmsCircleUtils';
  import { ignore } from '../../Common/tools';

  export let circleDetails = {}, isTemplate = false, pageChanged = false, historyButtonsVisible = false, savingPage = false;
  export let locales = [], currentLocale = '', defaultLocale = '';

  let dispatch = createEventDispatcher();

  let preview = () => {
    LmsCircleUtils.preview(circleDetails.circle);
  };

  let showMoreOptions = (event) => {
    const items = [
      ...(circleDetails.circle.published && !isTemplate ? [{
        icon: 'fa-eye-slash',
        text: M.UNPUBLISH_CIRCLE,
        tag: 'unpublish'
      }] : []),
      {
        icon: 'fa-trash',
        text: M.DELETE,
        tag: 'delete'
      },
      {
        icon: 'fa-clone',
        text: M.DUPLICATE,
        tag: 'duplicate'
      },
      {
        icon: 'fa-link',
        text: M.COPY_LINK_CAPITALIZED,
        tag: 'copy_link'
      }
    ];

    External.Tools.showTooltipOptions(External.jQuery(event.target), items, function(target, idx, text, tag) {
      switch (tag) {
        case 'delete':
          External.Tools.prompt('', M.DELETE_CIRCLE_QUESTION, async () => {
              await LmsCircleUtils.deleteCircle(circleDetails.circle);
              window.location.href = '/me/community/circles';
              //External.CPanel.goToUrl('/me/community/circles/', false);
            }, ignore
          );
          break;
        case 'duplicate':
          External.Tools.prompt('', M.CLONE_CIRCLE_QUESTION, async () => {
            let circle = await LmsCircleUtils.duplicateCircle(circleDetails);
            if (circle) {
              External.CPanel.goToUrl('/me/community/circles/' + circle.url);
            }
          }, ignore);
          break;
        case 'copy_link':
          LmsCircleUtils.copyCircleUrl(circleDetails.circle);
          break;
        case 'unpublish':
          dispatch('unpublish');
          break;
      }
    });
  };

  let showCircleAnalytics = () => {
    LmsCircleUtils.showAnalytics(circleDetails, circleDetails.circle, 'CIRCLE');
  };

  // Open the shared language panel (globe). Switching routes back through the circle's own
  // changeLocale (which guards unsaved changes and reloads with the chosen locale).
  let openLanguagePanel = () => {
    if (!External.Multilingual || !External.Multilingual.open) {
      return;
    }
    External.Multilingual.open({
      getCurrentLocale: () => currentLocale,
      switchTo: (locale) => dispatch('localechange', locale)
    });
  };

  $: showLanguageGlobe = External.Multilingual && External.Multilingual.isEnabled
    ? External.Multilingual.isEnabled()
    : locales.length > 1;
  $: activeLocaleCode = (currentLocale || defaultLocale || 'en').toUpperCase();

</script>

<div class="advanced-buttons-wrapper no-selection">
  <div class="inner-wrapper flex align-center space-between">
    <div class="flex-1 flex align-center">
      {#if !isTemplate}
        <a href="/me/community/circles" rel="tab" class="advanced-circle-button circle-effect f-left">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z" />
          </svg>
        </a>
      {/if}
      <div class="circle-viewports flex align-center f-left">
        <svg class="active" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
          <path
            d="M320-120v-80h80v-80H160q-33 0-56.5-23.5T80-360v-400q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v400q0 33-23.5 56.5T800-280H560v80h80v80H320ZM160-360h640v-400H160v400Zm0 0v-400 400Z" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
          <path
            d="M400-160h160v-40H400v40ZM280-40q-33 0-56.5-23.5T200-120v-720q0-33 23.5-56.5T280-920h400q33 0 56.5 23.5T760-840v720q0 33-23.5 56.5T680-40H280Zm0-200v120h400v-120H280Zm0-80h400v-400H280v400Zm0-480h400v-40H280v40Zm0 560v120-120Zm0-560v-40 40Z" />
        </svg>
        <span class="circle-starting-screen-btn">{M.STARTING_SCREEN}</span>
      </div>
    </div>
    <div class="flex-none align-center justify-center flex">
      {#if showLanguageGlobe}
        <a on:click={openLanguagePanel} class="advanced-circle-button circle-effect circle-multilingual-btn f-left"
           title={M.MULTILINGUAL_CIRCLE_BUTTON_TOOLTIP}>
          <span class="material-icons-outlined">language</span>
          <span class="circle-multilingual-code">{activeLocaleCode}</span>
        </a>
      {/if}
      <a on:click={() => dispatch('settings')} class="advanced-circle-button circle-effect f-left">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        </svg>
      </a>
      <a on:click={() => dispatch('styling')} class="advanced-circle-button circle-effect f-left">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
          <path d="M0 0h24v24H0V0z" fill="none"></path>
          <path
            d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"></path>
        </svg>
      </a>
      {#if !isTemplate}
        <a on:click={showCircleAnalytics} class="advanced-circle-button circle-effect f-left">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
            <path
              d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"></path>
          </svg>
        </a>
        <!--
        <a class="advanced-circle-button circle-effect f-left">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
            <path
              d="M880-80 720-240H320q-33 0-56.5-23.5T240-320v-40h440q33 0 56.5-23.5T760-440v-280h40q33 0 56.5 23.5T880-640v560ZM160-473l47-47h393v-280H160v327ZM80-280v-520q0-33 23.5-56.5T160-880h440q33 0 56.5 23.5T680-800v280q0 33-23.5 56.5T600-440H240L80-280Zm80-240v-280 280Z"></path>
          </svg>
        </a>-->
      {/if}
      <!--
      <a class="advanced-circle-button circle-effect f-left" on:click={(event) => preview(event)}>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
          <path
            d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143ZM233-120l65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Zm247-350Z"></path>
        </svg>
      </a>-->
      {#if !isTemplate}
        <a class="advanced-circle-button circle-effect f-left" on:click={(event) => showMoreOptions(event)}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000">
            <path
              d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z"></path>
          </svg>
        </a>
      {/if}
    </div>
    <div class="flex-1">
      <div class="lms-page-change-controls page-changes-controls mt-0 mb-0" class:visibility-hidden={!pageChanged && !historyButtonsVisible}>
        <div class="f-right grid-history-buttons-wrapper" id="lmsGridHistoryButtons">
          <a class="undo-redo-btn rounded-effect disabled button-tooltip" data-tooltip="undo" data-bottom="true" data-action="undo" on:click={() => dispatch('undo')}>
            <span class="material-icons"> undo </span></a>
          <a class="undo-redo-btn rounded-effect disabled button-tooltip" data-tooltip="redo" data-bottom="true" data-action="redo" on:click={() => dispatch('redo')}>
            <span class="material-icons"> redo </span></a>
        </div>
        <div class="save-buttons f-right mr-5" id="websitePageSaveBtns" class:none={!pageChanged}>
          <a class="discard-changes" on:click={() => dispatch('discard')}>{M.DISCARD_CHANGES_BTN}</a>
          <a class="green middle-button rounded-effect" class:disabled={savingPage} on:click={() => dispatch('save')}>
            <span class="material-icons"> done </span>
            {M.SAVE}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .circle-multilingual-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .circle-multilingual-btn .circle-multilingual-code {
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    letter-spacing: 0.3px;
  }
</style>
